<template>
    <div class="column is-four-fifths" v-if="selectedEvents.length > 0">
        <div>
            <p class="mb-3">{{ translate("notification_center.choose_filters") }}</p>

            <div class="buttons">
                <MultiSelectDropdown
                    ref="countryDropdown"
                    :trigger-text="translate('notification_center.country_filter')"
                    :items="countries"
                    :is-left="true"
                    :no-content-message="translate('notification_center.country_filter.no_countries')"
                    v-model="selectedCountries"
                >
                    <template v-slot:item="{ item }">
                        <span class="icon" :class="{ 'has-text-danger': item.key === COUNTRY_NOT_AVAILABLE }">
                            <i :class="item.icon" />
                        </span>
                        <span>
                            {{ item.text }}
                        </span>
                        <span class="is-size-7">
                            <span class="icon is-small">
                                <i class="fa fa-user" />
                            </span>
                            <span>{{ item.users }}</span>

                            <template v-if="item.emails > 0">
                                <span class="icon is-small">
                                    <i class="fa fa-envelope" />
                                </span>
                                <span>{{ item.emails }}</span>
                            </template>

                            <template v-if="item.phones > 0">
                                <span class="icon is-small">
                                    <i class="fa fa-mobile-alt" />
                                </span>
                                <span>{{ item.phones }}</span>
                            </template>
                        </span>
                    </template>
                </MultiSelectDropdown>

                <PaymentStatusFilter />

                <button class="button" @click="resetFilters">
                    <span class="icon">
                        <i class="fa fa-times" />
                    </span>
                    <span>{{ translate("common.reset") }}</span>
                </button>
            </div>

            <div class="mt-3 has-text-centered">
                <p class="mb-2 is-size-5">{{ translate("notification_center.number_of_receivers") }}</p>

                <ReceiversSummary :users="users" :phones="phones" :emails="emails" />
            </div>

            <div class="mt-3 mb-2">{{ translate("notification_center.current_filter") }}</div>
            <SelectedFilters />
        </div>
    </div>
    <div class="column is-four-fifths" v-else>
        <Notification class="is-danger has-text-centered">
            <span class="icon">
                <i class="fa fa-exclamation-triangle" />
            </span>
            <span>{{ translate("notification_center.choose_events_first") }}</span>
        </Notification>
    </div>
</template>

<script>
    import MultiSelectDropdown from "../../Common/MultiSelectDropdown";
    import apiMixin from "../../Api/apiMixin";
    import { mapState } from "vuex";
    import translatorMixin from "../../Common/translatorMixin";
    import SelectedFilters from "./SelectedFilters";
    import PaymentStatusFilter from "./PaymentStatusFilter";
    import ReceiversSummary from "./ReceiversSummary";
    import Notification from "../../Common/Notification";
    import { COUNTRY_NOT_AVAILABLE } from "../../Common/consts";

    export default {
        name: "filter-receivers-step",
        components: { Notification, ReceiversSummary, PaymentStatusFilter, SelectedFilters, MultiSelectDropdown },
        mixins: [apiMixin, translatorMixin],
        data() {
            return {
                countries: [],
            };
        },
        computed: {
            ...mapState("choosingSourceEvents", ["selectedEvents"]),
            ...mapState("filteringReceivers", ["users", "phones", "emails"]),
            selectedCountries: {
                set(value) {
                    this.$store.commit("filteringReceivers/setSelectedCountries", value);
                },
                get() {
                    return this.$store.state.filteringReceivers.selectedCountries;
                },
            },
        },
        watch: {
            selectedCountries: {
                handler() {
                    this.$store.dispatch("filteringReceivers/getSearchSummary");
                },
                deep: true,
            },
        },
        created() {
            this.COUNTRY_NOT_AVAILABLE = COUNTRY_NOT_AVAILABLE;
        },
        mounted() {
            return this.$store
                .dispatch("filteringReceivers/getSearchSummary")
                .then(() => {
                    return this.notificationsCenterApi().getCountriesSummary(this.selectedEvents);
                })
                .then(countriesResponse => {
                    this.countries = countriesResponse.map(country => {
                        let iconClass = "flag-icon flag-icon-" + country.country.toLowerCase();

                        if (country.country === COUNTRY_NOT_AVAILABLE) {
                            iconClass = "fas fa-question-circle";
                        }

                        return {
                            icon: iconClass,
                            text: this.translateCountryCode(country.country),
                            key: country.country,
                            users: country.users,
                            phones: country.phones,
                            emails: country.emails,
                        };
                    });
                });
        },
        methods: {
            resetFilters() {
                this.$refs.countryDropdown.clearAll();
                this.$store.dispatch("filteringReceivers/resetFilters");
            },
        },
    };
</script>

<style scoped></style>
